import appHistory from "../app/appHistory";

const formPathWithSearchParams = (params: IFormPathWithSearchParams, pathname: string = '') => {
    const urlParams = new URLSearchParams(window.location.search);
    Object.entries(params).forEach(([key, value]) => {
        if (value || value === 0) {
            urlParams.set(key, `${value}`);
        } else {
            urlParams.delete(key);
        }
    });

    return `${pathname || appHistory.location.pathname}?${urlParams.toString()}`;
}

export default formPathWithSearchParams;

export interface IFormPathWithSearchParams {
   [name: string]: string | number | null | undefined;
}
